import { AppSettings } from "../types/appSettings";
import { initialState } from "../../external/store/initialState";
import { actionTypeKeys } from "../../external/actions/actionTypeKeys";
import { AnyAction } from "redux";

export default function appSettingsReducer(
  state: AppSettings = initialState.appSettings,
  action: AnyAction
): AppSettings {
  switch (action.type) {
    case actionTypeKeys.LOAD_APP_SETTINGS_SUCCESS:
      return { ...action.appSettings };
    default:
      return state;
  }
}
